var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00684 7.47998V10.4733C2.00684 13.4666 3.20684 14.6666 6.20017 14.6666H9.7935C12.7868 14.6666 13.9868 13.4666 13.9868 10.4733V7.47998",
    stroke: "#1E293B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 8.00004C9.21999 8.00004 10.12 7.00671 9.99999 5.78671L9.55999 1.33337H6.44666L5.99999 5.78671C5.87999 7.00671 6.77999 8.00004 7.99999 8.00004Z",
    stroke: "#1E293B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2065 8.00004C13.5532 8.00004 14.5399 6.90671 14.4065 5.56671L14.2199 3.73337C13.9799 2.00004 13.3132 1.33337 11.5665 1.33337H9.5332L9.99987 6.00671C10.1132 7.10671 11.1065 8.00004 12.2065 8.00004Z",
    stroke: "#1E293B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75992 8.00004C4.85992 8.00004 5.85325 7.10671 5.95992 6.00671L6.10659 4.53337L6.42659 1.33337H4.39325C2.64659 1.33337 1.97992 2.00004 1.73992 3.73337L1.55992 5.56671C1.42659 6.90671 2.41325 8.00004 3.75992 8.00004Z",
    stroke: "#1E293B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 11.3334C6.88683 11.3334 6.3335 11.8867 6.3335 13V14.6667H9.66683V13C9.66683 11.8867 9.1135 11.3334 8.00016 11.3334Z",
    stroke: "#1E293B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/Warehouse.f11d4942aa7b34537dcc37acd69dd59c.svg";
export { ForwardRef as ReactComponent };